module.exports = __webpack_public_path__ + "static/media/category-icon.1ee0129c.svg";